import { parseTemplate } from 'url-template';
import { CaLabeling } from '~/Api/User/ProductGroup/CaLabeling/CaLabeling';
import { ErrorResponse } from '~/Api/User/ProductGroup/CaLabeling/ErrorResponse';
import { mapCaLabeling } from '~/Api/User/ProductGroup/CaLabeling/mapCaLabeling';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

export interface Result {
	caLabeling: CaLabeling;
}

export const findCaLabeling = async (client: ApiClient, userId: string, groupId: string): Promise<Result> => {
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/ca-labeling');

	try {
		const request = await client.fetch(url.expand({ userId, groupId }));
		const response = await request.json();
		return { caLabeling: mapCaLabeling(response.caLabeling) };
	} catch (error) {
		throw error instanceof ApiClientErrorResponse
			? new ErrorResponse(error.request, error.statusCode, error.errors)
			: error;
	}
};
